export function toBubbleSize(score: number | null): number {
  if (score === null) {
    return 0;
  } else {
    return Math.min(Math.max(score * 20, 10), 45);
  }
}

export function toBubbleColor(value: number | null, score: string, colors: string[]): string {
  if (value === null) {
    return "#ECF3F4";
  } else {
    if (score === "rate") {
      if (value < 0.05) {
        return colors[0];
      } else if (value < 0.1) {
        return colors[1];
      } else if (value < 0.2) {
        return colors[2];
      } else if (value < 0.3) {
        return colors[3];
      } else {
        return colors[4];
      }
    } else {
      if (value < 0.9) {
        return colors[0];
      } else if (value < 1) {
        return colors[1];
      } else if (value < 1.4) {
        return colors[2];
      } else if (value < 1.8) {
        return colors[3];
      } else {
        return colors[4];
      }
    }
  }
}
